// The change log. What was sent, what came back, and what can be reversed.
import React from 'react';
import s from '../KeywordOptimiser.module.css';
import { FEATURE_LABEL } from '../format';

export default function Changes({ changes, loading, onUndo, busy }) {
  if (loading) return <p className={s.empty}>Loading…</p>;
  if (!(changes || []).length) {
    return (
      <p className={s.empty}>
        Nothing has been applied yet. Every change that is will be recorded here with
        what was sent, what Amazon said, and a way to undo it.
      </p>
    );
  }
  return (
    <div className={s.tableWrap}>
      <table className={s.table}>
        <thead>
          <tr><th>When</th><th>What</th><th>Outcome</th><th /></tr>
        </thead>
        <tbody>
          {changes.map((c, index) => (
            <tr key={`${c.suggestion_id}-${index}`}>
              <td className={s.thin}>{String(c.at).slice(0, 16).replace('T', ' ')}</td>
              <td>
                <span className={s.sugFeature}>
                  {FEATURE_LABEL[c.kind?.split('_')[0]?.toLowerCase()] || c.kind}
                </span>
                <div>{c.headline}</div>
              </td>
              <td className={s.thin}>
                {c.undone ? 'Undone'
                  : c.outcome?.failed ? `Failed: ${c.outcome.failed.reason}`
                    : 'Applied'}
              </td>
              <td>
                {!c.undone && !c.outcome?.failed && (
                  <button className={s.linkButton} disabled={busy}
                          onClick={() => onUndo(c.suggestion_id)}>Undo</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
